// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { ServiceDeployment_abstract } from './../../abstract/SagaBase/Objects/ServiceDeployment_abstract';
export class ServiceDeployment extends ServiceDeployment_abstract {}
